import React from 'react';

const Background = (props) => (
  <div className="searchRubrica-background" {...props} />
);

export default Background;
